// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kleavor: PokeData = {
  "id": 900,
  "name": "kleavor",
  "height": 18,
  "weight": 890,
  "base_experience": 175,
  "types": [
    PokeType.BUG,
    PokeType.ROCK
  ],
  "api_moves": [
    "swords-dance",
    "leer",
    "agility",
    "quick-attack",
    "double-team",
    "focus-energy",
    "rock-slide",
    "slash",
    "false-swipe",
    "fury-cutter",
    "silver-wind",
    "aerial-ace",
    "close-combat",
    "air-slash",
    "x-scissor",
    "stealth-rock",
    "double-hit",
    "smack-down",
    "stone-axe"
  ],
  "moves": [
    "leer",
    "quick-attack",
    "rock-slide",
    "aerial-ace",
    "close-combat",
    "air-slash",
    "stealth-rock",
    "stone-axe",
    "bug-buzz",
    "signal-spam",
    "pin-missile",
    "rock-blast",
    "rock-smash"
  ],
  "evolution_chain": {
    "id": 58,
    "item": null,
    "species": [
      {
        "name": "scyther",
        "order": 141,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "scizor",
        "order": 142,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 123,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kleavor",
        "order": 900,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 123,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "black-augurite"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 115,
    "ability_power": 182
  },
  "stat_changes": [],
  "catch_rate": 115,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
